import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useMutation } from 'react-apollo';
import { toast } from 'react-toastify';
import { displayError } from '../utilities';
import { UPSERT_CATEGORY } from '../queries';

const AddEditCategoryModal = ({
  isOpen,
  toggle,
  isEdit,
  category,
  onSuccess
}) => {
  const [name, setName] = useState('');
  const [iconFile, setIconFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');

  useEffect(() => {
    if (!isOpen) return;

    if (category) {
      setName(category.name);
      setPreviewUrl(category.iconLink || '');
      setIconFile(null);
      return;
    }

    setName('');
    setIconFile(null);
    setPreviewUrl('');
  }, [category, isOpen]);

  const onFileChange = e => {
    const file = e.target.files[0];
    if (file) {
      setIconFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const [upsertCategory, { loading }] = useMutation(UPSERT_CATEGORY);

  const handleSave = async () => {
    try {
      await upsertCategory({
        variables: {
          id: isEdit ? category.id : null,
          name,
          iconFile: iconFile || null
        }
      });

      toast.success(
        `${isEdit ? 'Updated' : 'Added'} category ${name} successfully`,
        { autoClose: 3000 }
      );

      if (onSuccess) onSuccess();
      toggle();
    } catch (e) {
      displayError(e);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {isEdit ? 'Edit Category' : 'Add Category'}
      </ModalHeader>

      <ModalBody>
        <div className="mapping-form">
          <div className="mapping-form-row">
            <label>Category Name</label>

            <input
              type="text"
              className="form-control"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Enter category name"
            />
          </div>

          <div className="mapping-form-row">
            <label>Category Icon</label>

            <div className="icon-upload-section">
              {previewUrl && (
                <div className="icon-preview-wrapper mb-3">
                  <img
                    src={previewUrl}
                    alt="Preview"
                    className="category-icon-preview"
                    style={{
                      width: 80,
                      height: 80,
                      objectFit: 'contain',
                      border: '1px solid #ddd',
                      padding: 5,
                      borderRadius: 4
                    }}
                  />
                </div>
              )}

              <input
                type="file"
                className="form-control-file"
                accept="image/*"
                onChange={onFileChange}
              />
            </div>
          </div>
        </div>
      </ModalBody>

      <ModalFooter className="mapping-modal-footer">
        <Button
          className="mapping-save-btn"
          disabled={loading || !name || (!isEdit && !iconFile)}
          onClick={handleSave}
        >
          {loading ? 'Saving...' : 'Save'}
        </Button>

        <Button className="mapping-cancel-btn" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AddEditCategoryModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  isEdit: PropTypes.bool,
  category: PropTypes.object,
  onSuccess: PropTypes.func
};

export default AddEditCategoryModal;
